import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const Testimonial = (certificates) => {
  const { title, platform, skills, date, image, credential } = certificates;
  return (
    <Box
      sx={{
        backgroundColor: "#000F2E", //000F2E
        padding: 3,
        border: "1px solid #0f337e",
        borderRadius: "10px",
        width: "80%",
        "@media (min-width: 1000px)": {
          maxWidth: "1000px",
        },
        position: "relative",
        display: "flex",
        mx: 3,
      }}
    >
      <Box
        component="img"
        sx={{ maxHeight: "45px", maxWidth: "45px", objectFit: "cover" }}
        src={image}
      />
      <a href={credential} target="_blank" rel="noopener">
        <Box
          sx={{
            maxWidth: "1000px",
            mx: 2,
          }}
        >
          <Typography sx={{ color: "white", mb: 0 }}>{title}</Typography>

          <Typography variant="body1" sx={{ color: "white", mb: 0 }}>
            {platform}
          </Typography>
          <Typography variant="body2">
            <span style={{ color: "#B3565B", fontWeight: "bold" }}>
              {date}{" "}
            </span>
            <span style={{ color: "#7B89A8" }}> {skills}</span>
          </Typography>
        </Box>
      </a>
    </Box>
  );
};

export default Testimonial;
